import retryCallIfNeeded from '../../../restCalls';

const basePath = window.__ENV.REACT_APP_BASE_PATH || '/application';
const communicationBase = `${basePath}/communication`;

export default function CommunicationsService(client) {
  const validateEmail = (emailId, signal) => retryCallIfNeeded(client, () => client
    .get(`${communicationBase}/validate-email?email=${emailId}&forceFallback=false&synthetic=false`, { signal}));

  const validatePhone = (phone) => retryCallIfNeeded(client, () => client
    .get(`${communicationBase}/validate-phone?phone=${encodeURIComponent(phone)}`));

  return {
    validateEmail,
    validatePhone,
  };
}
